import React from "react";
import { AddGenreHomeSectionModalTemplate } from "themes/administration/naki-mobile/components";

function AddGenreHomeSectionModal(props) {
    return <AddGenreHomeSectionModalTemplate {...props} />;
}

export default AddGenreHomeSectionModal;
